import React from 'react';
import {
  StyleSheet, TouchableOpacity, Text,
} from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  button: {
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    marginRight: 8,
    height: 42,
    minHeight: 42,
    backgroundColor: '#52b788',
  },
  buttonEnabled: {
    opacity: 1,
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  text: {
    color: 'white',
    textTransform: 'uppercase',
    fontSize: 12,
  },
});

const Button = ({
  text,
  onPress,
  disabled,
  style,
}) => (
  <TouchableOpacity
    onPress={onPress}
    style={[styles.button, disabled ? styles.buttonDisabled : styles.buttonEnabled, style]}
    disabled={disabled}
  >
    <Text style={styles.text}>{text}</Text>
  </TouchableOpacity>
);

Button.defaultProps = {
  disabled: false,
};
export default Button;
